
export const ACCESS = {
  FamilyViewAccess: false,
  FamilyAccess: false,
  FamilyWithoutNationalCodeAccess: false,
  ProblemViewAccess: false,
  ProblemAccess: false,
  UserViewAccess: false,
  UserAccess: false,
  BranchViewAccess: false,
  BranchAccess: false,
  RoleViewAccess: false,
  RoleAccess: false,
  HebehAccess: false,
  EventLogViewAccess: false,
  PlanViewAccess: false,
  PlanAccess: false,
  DocumentViewAccess: false,
  DocumentAccess: false,
  DashboardViewAccess: false,
  DashboardUserActivityInLastMonth: false,
  DashboardBranchActivityInLastMonth: false,
  DashboardActivateBranchesInLastMonth: false,
  DashboardActivateUsersInLastMonth: false,
  DashboardHebeh: false,
  DashboardSubBranches: false,
  BranchChangeParent: false,
  ReportSearchZone: false,
  ReportHasNationalCode: false,
  ReportIsEnable: false,
  ReportInformationStatus: false,
  ReportRegisterDate: false,
  ReportBirthDayDate: false,
  ReportGenderType: false,
  ReportDocumentStatus: false,
  ReportHeadOfHouseHoldStatus: false,
  ReportFundamentalProblem: false,
  ReportNeedyLevel: false,
  ReportHouseStatus: false,
  ReportSponsors: false,
  ReportSocialHarms: false,
  ReportAddress: false,
  ReportMarriedStatus: false,
  ReportInsuranceStatus: false,
  ReportInsuranceType: false,
  ReportAccountInformation: false,
  ReportBranchFilter: false,
  AccessRight: false,
  ChangeParentBranch: false,
  ChangeFamilyBranch: false,
  ChangeBranchRole: false,
  ExportExcel: false,
  ExportExcelName: false,
  ExportExcelLastName: false,
  ExportExcelNationalCode: false,
  ExportExcelFatherName: false,
  ExportExcelEducationLevel: false,
  ExportExcelMaritalStatus: false,
  ExportExcelBirthCity: false,
  ExportExcelBirthDate: false,
  ExportExcelMonthlyExpense: false,
  ExportExcelBranch: false,
  ExportExcelActiveStatus: false,
  ExportExcelAddress: false,
  CategoryViewAccess: false,
  CategoryAccess: false,
  CategoryFeatureViewAccess: false,
  CategoryFeatureAccess: false,
  CategoryReferenceMedical: false,
  FamilyDeactiveAccess: false,
  BranchProblemViewAccess: false,
  ProMiServeAccess: false,
  ChatSupportAccess: false,
  MapViewAccess: false,
  VerifyQuestionsRequests: false,
  CategoriesPictures: false,
  VerifyProblemAccess: false,
  ProblemStatusAccess: false,
  VerifyBranchRequestView: false,
  AllMightyServesAccessView: false,
  CampaignCategoryAccess: false,
  MemberAccess: false,
  MemberViewAccess: false,
  OtherMightyServesAccess: false,
  BranchesAccess: false,
  UsersCommentsAccess: false,
  UsersComplaintsAccess: false,
  AllTransactionsAccessView: false,
  AddNewTransaction: false,
  SayehAdmin: false,
  CampaignViewAccess: false,
  ChangeStatusGalleryAccess: false,
  ChangeStatusAdminCheckListAccess: false,
  MemberReportAccess: false,
  ChangeStatusProblemFeatureAnswerAccess: false,
  EditProblemFeatureAnswerImageAccess: false,
};
